/**
 * Valid Teams RingIds. Retrieved from Teams SDK.
 *
 * Descriptions: https://aka.ms/teamsrings
 *
 * ringId property ref: https://learn.microsoft.com/en-us/javascript/api/@microsoft/teams-js/app.apphostinfo?view=msteams-client-js-latest#@microsoft-teams-js-app-apphostinfo-ringid
 */ export var TeamsRingId = /*#__PURE__*/ function(TeamsRingId) {
    /** Teams canary, or engineering self-host */ TeamsRingId["ring0"] = "ring0";
    /** Teams slimcore in ring0 */ TeamsRingId["ring0_s"] = "ring0_s";
    /** Teams internal folks, Teams org, selected test tenants */ TeamsRingId["ring1"] = "ring1";
    /** Teams Beta/TAP tenant admins, IT Admins Feature Preview, IT Pro early adopters */ TeamsRingId["ring1_5"] = "ring1_5";
    /** Teams Early Developer Partners Preview */ TeamsRingId["ring1_6"] = "ring1_6";
    /** Teams Microsoft Inner Ring, Microsoft Internal, Microsoft Dogfood */ TeamsRingId["ring2"] = "ring2";
    /** Teams External TAP, Beta Users, External users via Beta/TAP Program, Insiders */ TeamsRingId["ring3"] = "ring3";
    /** Teams Public Preview, Targeted Release and Developer Preview.
     * External early adopters evaluating pre-release features */ TeamsRingId["ring3_6"] = "ring3_6";
    /** Teams Microsoft Outer Ring. All Microsoft */ TeamsRingId["ring3_9"] = "ring3_9";
    /** Teams Public. Worldwide, General Ring, General Audience, GA */ TeamsRingId["general"] = "general";
    return TeamsRingId;
}({});
/**
 * Used in TeamsTasksService API to determine the partner scenario.
 */ export const teamsTasksApiPartnerName = "planner";
/** Query parameters used by Uno Teams */ export var TeamsTabQueryParams = /*#__PURE__*/ function(TeamsTabQueryParams) {
    /** Tab route details. Should be a properly-formatted deep link path. */ TeamsTabQueryParams["PlanRoute"] = "planRoute";
    return TeamsTabQueryParams;
}({});
/** Planner teams tab Id */ export const TeamsPlannerTabId = "com.microsoft.teamspace.tab.planner";
export var TeamsChannelType = /*#__PURE__*/ function(TeamsChannelType) {
    TeamsChannelType["Standard"] = "Standard";
    TeamsChannelType["Shared"] = "Shared";
    TeamsChannelType["Private"] = "Private";
    return TeamsChannelType;
}({});
export var WebUrlSegments = /*#__PURE__*/ function(WebUrlSegments) {
    /** Planner Service Teams UI prefix (new) */ WebUrlSegments["PlannerServiceTeamsPathSegment"] = "ui/teams";
    /** Legacy */ WebUrlSegments["LegacyMtrsTeamsPathSegment"] = "teamsui";
    return WebUrlSegments;
}({});
/** Legacy MTRS Teams service worker script path */ export const LegacyMtrsTeamsServiceWorkerPath = `/${"teamsui"}/service-worker.js`;
/** Default text to show in channel icon when channel name empty */ export const DefaultChannelIconText = "C";
/** Maximum number of context links allowed per plan */ export const MaxPlanContextLinks = 10;
